/* Product Tile Markup - You can play around with this to change the
information that appears on the Wishlisted Product tiles  */

// Modal-specific template (keep name unique from wishlist page script)
const productCardModalMarkup = `
	<style>
	/* Style for swym custom wishlist */
	.swym-wishlist-grid .swym-wishlist-item {
		flex: 0 0 30%;
		margin: 0px;
		margin-bottom: 50px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}

	.swym-wishlist-grid .swym-is-anchor {
		opacity: 1;
		cursor: pointer;
		text-decoration: none;
		touch-action: manipulation;
		align-items: center;
	}
	.swym-delete-btn.swym-nav.swym-nav-1.swym-is-button:before {
    	content: "Remove Favorite";
		font-size:16px;
	}
	.swym-is-button:disabled {
    	cursor: not-allowed;
	}
  #modal-wishlist .swym-wishlist-item [id^="swym-custom-add-toCartBtn"].swym-added[disabled],
	#modal-wishlist .swym-wishlist-item:hover [id^="swym-custom-add-toCartBtn"].swym-added[disabled] {
		box-shadow: none !important;
		background: #39861E !important;
		color: var(--nw-white) !important;
		opacity: .4 !important;
	}
#modal-wishlist [id^="swym-custom-add-toCartBtn"] {
		position: relative;
	}
#modal-wishlist [id^="swym-custom-add-toCartBtn"]::after {
		content: 'Add to Cart';
		display: inline-block;
	}
#modal-wishlist [id^="swym-custom-add-toCartBtn"].swym-added::after,
#modal-wishlist [id^="swym-custom-add-toCartBtn"][data-state-cart='swym-added']::after {
		content: 'Added to Cart';
	}
	</style>

	<div class="swym-wishlist-grid" role="dialog">
	{{#products}} 
		<div aria-label="Product: {{dt}}"  role="group" class="swym-wishlist-item swym-is-anchor">

		<div class="swym-wishlist-image-wrapper" data-product-url="{{du}}" aria-hidden="true" tabindex="-1">
			<img alt="{{ dt }}" class="swym-wishlist-image" src="{{iu}}">
		</div>

		<a href="{{du}}" class="swym-is-button swym-title-link" role="link" aria-label="View {{dt}}">
			<div class="swym-title swym-title-1">
				{{dt}}
			</div>
		</a>

		<div class="swym-variant-title swym-text swym-title-2 swym-variant-title-spacer">
       		{{variantinfo}}
     	</div>

		<div class="swym-product-price swym-text swym-text-1">
			<div class="swym-product-final-price swym-value">
				{{cu}}{{pr}}
			</div>
		</div>

		<button 
			id="swym-custom-add-toCartBtn-{{empi}}" 
			{{#isOutOfStock}} disabled {{/isOutOfStock}} 
			{{#isInCart}} disabled {{/isInCart}}
			data-state-cart="{{#isInCart}}swym-added{{/isInCart}}" 
			data-product-url="{{du}}" 
			data-variant-id="{{epi}}" 
			data-product-id="{{empi}}"
      class="swym-add-to-cart-btn swym-button swym-button-1 swym-is-button swym-is-button {{#isOutOfStock}}out-of-stock{{/isOutOfStock}} {{#isInCart}}swym-added{{/isInCart}} {{^isInCart}}not-added{{/isInCart}}"
		>
    </button>
    <button 
			id="swym-remove-productBtn-{{empi}}" 
			data-variant-id="{{epi}}" 
			data-product-id="{{empi}}" 
			class="swym-delete-btn swym-nav swym-nav-1 swym-is-button"
		>
		</button>
	 </div>
   {{/products}}
</div>`;

const noProductsMessageMarkup = `<div class="swym-empty-wishlist-container">
	<h3 class="swym-empty-wishlist-title swym-heading swym-heading-1">No Favorites saved yet.</h3>
	<p class="swym-empty-wishlist-text swym-text swym-text-1">Browse all products now.</p>

	<a class="swym-empty-wishlist-continue-btn" href="/collections/all">Shop All</a>
</div>`;

const wishlistContainerMain = document.querySelector(
  '#modal-wishlist .swym-ui-component'
);
const wishlistCloseButtonMain = document.querySelector(
  '#modal-wishlist .swym-ui-component button.modal-exit'
);
const wishlistModal = document.getElementById('modal-wishlist');
const wishlistModalOverlay = document.getElementById(
  'modal-overlay-backdrop'
);
const wishlistIcon = document.getElementById('header-wishlist');
let wishlistFocusTrapEnabled = false;
let wishlistKeydownHandler = null;
let wishlistModalObserver = null;

function setWishlistModalInteractivity(isOpen) {
  if (!wishlistModal) return;
  if (isOpen) {
    wishlistModal.removeAttribute('aria-hidden');
    wishlistModal.removeAttribute('hidden');
    wishlistModal.removeAttribute('inert');
  } else {
    wishlistModal.setAttribute('aria-hidden', 'true');
    wishlistModal.setAttribute('hidden', '');
    wishlistModal.setAttribute('inert', '');
  }
}

function enableWishlistFocusTrap() {
  if (wishlistFocusTrapEnabled) return;
  const focusContainer = wishlistModal || wishlistContainerMain;

  const getFocusable = () =>
    Array.from(
      focusContainer.querySelectorAll(
        "a[href], button:enabled, [tabindex]:not([tabindex^='-']), input:not([type='hidden']):enabled, select:enabled, textarea:enabled, [role='button']"
      )
    ).filter(
      (el) => !el.hasAttribute('disabled') && el.offsetParent !== null
    );

  wishlistKeydownHandler = (event) => {
    if (event.key !== 'Tab') return;
    // Only trap when modal is open
    if (!(wishlistModal && wishlistModal.classList.contains('open')))
      return;

    const focusables = getFocusable();
    if (!focusables.length) return;

    const first = focusables[0];
    const last = focusables[focusables.length - 1];

    if (
      event.shiftKey &&
      (document.activeElement === first ||
        document.activeElement === focusContainer)
    ) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  document.addEventListener('keydown', wishlistKeydownHandler, true);
  wishlistFocusTrapEnabled = true;
}

function disableWishlistFocusTrap() {
  if (!wishlistFocusTrapEnabled) return;

  if (wishlistKeydownHandler) {
    document.removeEventListener(
      'keydown',
      wishlistKeydownHandler,
      true
    );
    wishlistKeydownHandler = null;
  }

  wishlistFocusTrapEnabled = false;
}

function getVariantInfo(variants) {
  try {
    let variantKeys =
        variants && variants != '[]'
          ? Object.keys(JSON.parse(variants)[0])
          : [],
      variantinfo;
    if (variantKeys.length > 0) {
      variantinfo = variantKeys[0];
      if (variantinfo == 'Default Title') {
        variantinfo = '';
      }
    } else {
      variantinfo = '';
    }
    return variantinfo;
  } catch (err) {
    return variants;
  }
}

function onAddToCartClick(e) {
  e.preventDefault();

  const productId = e.currentTarget.getAttribute('data-product-id');
  const variantId = e.currentTarget.getAttribute('data-variant-id');
  const du = e.target.getAttribute('data-product-url');
  e.target.classList.add('adding');
  e.target.classList.remove('not-added');
  window._swat.replayAddToCart(
    {
      empi: productId,
      du: du,
    },
    variantId,
    function (c) {
      e.target.innerHTML = '';
      e.target.classList.add('swym-added');
      e.target.classList.remove('adding');
      e.target.setAttribute('disabled', true);
      e.target.setAttribute('data-state-cart', 'swym-added');
      console.log('Successfully added product to cart.', c);
      /* update cart after adding a product to cart from wishlist */
      fetch('/cart.js')
        .then((res) => res.json())
        .then((updateCart) => {
          if (updateCart.item_count == 1) {
            jQuery('#cart-icon-bubble').append(
              '<div class="cart-count-bubble"><span aria-hidden="true">' +
                updateCart.item_count +
                '</span></div>'
            );
          } else {
            jQuery('.cart-count-bubble span').text(
              updateCart.item_count
            );
          }
        });
    },
    function (e) {
      console.log(e);
    }
  );
}

async function onRemoveBtnClick(e) {
  e.preventDefault();
  const epi = +e.currentTarget.getAttribute('data-variant-id');
  const empi = +e.currentTarget.getAttribute('data-product-id');
  window._swat.fetch(function (products) {
    products.forEach(function (product) {
      if (epi && empi && product.epi == epi && product.empi == empi) {
        window._swat.removeFromWishList(product, function () {
          if (!window.SwymCallbacks) {
            window.SwymCallbacks = [];
          }
          window.SwymCallbacks.push(swymRenderWishlist);
        });
      }
    });
  });
}

async function fetchProductData(wishlist) {
  const productDataPromises = wishlist.map(async (listItem) => {
    const response = await fetch(`${listItem.du.split('?')[0]}.js`);
    listItem.productData = await response.json();
    return listItem;
  });
  return Promise.all(productDataPromises);
}

async function swymRenderWishlist(swat) {
  // Get wishlist items

  await swat.fetch(function (products) {
    (async () => {
      //console.log("sym products");
      //console.log(products);

      const wishlistContentsContainer = document.getElementById(
        'wishlist-items-modal-container'
      );

      const wishlistedProducts = await fetchProductData(products);

      const formattedWishlistedProducts = wishlistedProducts.map(
        function (p) {
          p.pr = p.productData.price / 100;
          p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
          p.isInCart =
            _swat.platform.isInDeviceCart(p.epi) ||
            p.et == _swat.EventTypes.addToCart;
          p.variantinfo = p.vi ? getVariantInfo(p.vi) : '';
          p.isOutOfStock = p.stk == 0;
          p.iu = p.productData.featured_image;
          //console.log("next product p");
          //console.log(p);
          return p;
        }
      );

      //console.log("sym formattedWishlistedProducts");
      //console.log(formattedWishlistedProducts);

      if (formattedWishlistedProducts.length > 0) {
        const productCardsMarkup = SwymUtils.renderTemplateString(
          productCardModalMarkup,
          {
            products: formattedWishlistedProducts,
          }
        );
        if (wishlistContentsContainer) {
          wishlistContentsContainer.innerHTML = productCardsMarkup;
          attachClickListeners();
        } else {
          console.log(
            'Container not found, Wishlist Page element not found'
          );
        }
        // Add Wishlist count to header title
        const wishlistCountElem =
          document.getElementById('wishlistCount');
        wishlistContainerMain.style.display = 'block';
        wishlistCountElem.innerHTML = products.length;
      } else {
        wishlistContainerMain.style.display = 'block';
        wishlistContentsContainer.innerHTML = noProductsMessageMarkup;
      }

      focusOnModalPopup();
    })();
  });
}

function focusOnModalPopup() {
  const focusElementQuery = '#modal-wishlist .modal-close';
  if (document.querySelector(focusElementQuery) != null) {
    console.log('focusing on close for modal');
    const allInstances = document.querySelectorAll(focusElementQuery);
    console.log(
      'count for instances to focus = ' + allInstances.length
    );
    document.querySelector(focusElementQuery).focus();
    enableWishlistFocusTrap();
  }
}

function focusOnHeaderWishIcon() {
  const focusHeaderWishIcon = 'a#header-wishlist';
  if (document.querySelector(focusHeaderWishIcon) != null) {
    console.log('focusing on header wish icon');
    const allInstances = document.querySelectorAll(
      focusHeaderWishIcon
    );
    console.log(
      'count for instances to focus = ' + allInstances.length
    );
    document.querySelector(focusHeaderWishIcon).focus();
  }
}

function attachClickListeners() {
  // IDs are suffixed with the product ID, so select by prefix to catch all buttons
  const addToCartButtons = document.querySelectorAll(
    "[id^='swym-custom-add-toCartBtn']"
  );
  const removeBtns = document.querySelectorAll(
    "[id^='swym-remove-productBtn']"
  );
  const imageWrappers = document.querySelectorAll(
    '#modal-wishlist .swym-wishlist-image-wrapper[data-product-url]'
  );

  //   Add to cart Btns
  for (let i = 0; i < addToCartButtons.length; i++) {
    addToCartButtons[i].addEventListener(
      'click',
      onAddToCartClick,
      false
    );
  }
  //   Remove Buttons
  for (let k = 0; k < removeBtns.length; k++) {
    removeBtns[k].addEventListener('click', onRemoveBtnClick, false);
  }
  // Image click → navigate (mouse only; aria-hidden)
  for (let j = 0; j < imageWrappers.length; j++) {
    imageWrappers[j].addEventListener('click', function () {
      const url = this.getAttribute('data-product-url');
      if (url) {
        window.location.href = url;
      }
    });
  }

  console.log('Events attached!');
}

if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}

window.SwymCallbacks.push(swymRenderWishlist); /* Init Here */

wishlistIcon.addEventListener('click', function () {
  window.SwymCallbacks.push(swymRenderWishlist); /* Init Here */

  // const modalWishlist = document.getElementById('modal-wishlist');

  // Toggle the class that changes display property
  // modalWishlist.classList.toggle('wishlistToggle');
});

function closeWishlistModal() {
  if (wishlistModal) {
    wishlistModal.classList.remove('open');
  }
  if (wishlistModalOverlay) {
    wishlistModalOverlay.classList.remove('visible');
  }
  document.body.classList.remove('modal-open');

  if (wishlistContainerMain) {
    wishlistContainerMain.style.display = 'none';
  }
  setWishlistModalInteractivity(false);
  disableWishlistFocusTrap();
  focusOnHeaderWishIcon();
}

if (wishlistCloseButtonMain) {
  wishlistCloseButtonMain.addEventListener(
    'click',
    closeWishlistModal
  );
}
document.addEventListener('keydown', function (event) {
  if (event.key !== 'Escape') return;
  if (wishlistModal && wishlistModal.classList.contains('open')) {
    closeWishlistModal();
  }
});

if (wishlistModalOverlay) {
  wishlistModalOverlay.addEventListener('click', function () {
    if (wishlistModal && wishlistModal.classList.contains('open')) {
      closeWishlistModal();
    }
  });
}

function observeWishlistModalClose() {
  if (!wishlistModal || wishlistModalObserver) return;

  let previousState = wishlistModal.classList.contains('open');

  wishlistModalObserver = new MutationObserver(function () {
    const isOpen = wishlistModal.classList.contains('open');
    setWishlistModalInteractivity(isOpen);
    if (previousState && !isOpen) {
      // Modal just closed by any mechanism
      closeWishlistModal();
    }
    previousState = isOpen;
  });

  wishlistModalObserver.observe(wishlistModal, {
    attributes: true,
    attributeFilter: ['class'],
  });
}

observeWishlistModalClose();

setWishlistModalInteractivity(
  wishlistModal && wishlistModal.classList.contains('open')
);
